<!--
  The app's own page header, and outside the content padding the way every
  detail page places it: it spans the page rather than sitting on it as a card.
-->
<app-detail-page-header
    backLabel="Back to dashboard"
    backLink="/home/tasks"
    [title]="title"
    [metadata]="headerMetadata">
</app-detail-page-header>

<div class="app-content">
    @if (loading) {
        <app-loading-indicator></app-loading-indicator>
    } @else if (!rows.length) {
        <app-card [noMargin]="true" [showHeader]="false">
            <div card-body class="table-empty-state h-auto">
                <h2>Nothing in this stage</h2>
                <p>Work will appear here as it moves through the pipeline.</p>
            </div>
        </app-card>
    } @else {
        <!--
          The same split the dashboard's own lists use: a row on a wide screen,
          the app's mobile card below, rather than a desktop row squeezed onto a
          phone.
        -->
        <ul class="rows">
            @for (row of rows; track row.id) {
                <li class="row">
                    @if (row.overdue) {
                        <i
                            class="pi pi-exclamation-circle row-alert"
                            [attr.aria-label]="overdueLabel"
                            [pTooltip]="overdueLabel"></i>
                    }
                    <div class="row-text">
                        <h3 class="row-title m-0">{{ row.title }}</h3>
                        <p class="row-meta m-0">
                            @if (row.reference) {
                                <span>{{ row.reference }}</span>
                            }
                            <span>{{ row.moduleLabel }}</span>
                            <span>{{ row.ageLabel }}</span>
                        </p>
                    </div>
                    @if (row.routerLink) {
                        <a class="btn-secondary row-cta" [routerLink]="row.routerLink">
                            View
                        </a>
                    }
                </li>
            }
        </ul>

        <div class="mobile-rows">
            @for (row of rows; track row.id) {
                <app-flight-card-mobile [content]="'flex'">
                    <ng-container title>{{ row.title }}</ng-container>
                    <ng-container subtitle>{{ row.moduleLabel }}</ng-container>
                    @if (row.overdue) {
                        <!--
                          A badge in the card's status slot rather than an icon
                          before the title: inline it pushed the title off its
                          own line and left the two competing for the same row.
                        -->
                        <p-tag
                            status
                            severity="danger"
                            [value]="overdueBadgeLabel"
                            [pTooltip]="overdueLabel"></p-tag>
                    }
                    <ng-container content>
                        <div class="data-field">
                            @if (row.reference) {
                                <span>{{ row.reference }}</span>
                            }
                        </div>
                        <div class="data-field">
                            <span>{{ row.ageLabel }}</span>
                        </div>
                    </ng-container>
                    <ng-container actions>
                        @if (row.routerLink) {
                            <a
                                class="btn-secondary w-full"
                                [routerLink]="row.routerLink">
                                View
                            </a>
                        }
                    </ng-container>
                </app-flight-card-mobile>
            }
        </div>

        @if (listedTotal > pageSize) {
            <div class="list-footer">
                <span class="list-footer__report">{{ rangeLabel }}</span>
                <p-paginator
                    styleClass="assigned-items-paginator"
                    (onPageChange)="onPageChange($event)"
                    [first]="currentPage * pageSize"
                    [rows]="pageSize"
                    [totalRecords]="listedTotal"
                    [showCurrentPageReport]="false"
                    [showPageLinks]="false"
                    [showJumpToPageDropdown]="true">
                </p-paginator>
            </div>
        }
    }
</div>
